/**
 * Route state — current and previous URLs.
 *
 * Backs the legacy `EY_RAPToR_pushRouteState(url: NavElement)` /
 * `EY_RAPToR_getPreviousURL()` globals
 * (`route-state.service.ts:24-25`).
 *
 * NavElement (legacy shape): `{ currentRoute: string, fullRoute: string }`.
 *
 * The shell calls `pushRouteState()` when navigating (wired in router.tsx
 * via `router.subscribe('onResolved', ...)`); MFEs may also push directly
 * via the legacy global. `getPreviousURL()` returns the route before the
 * latest push — used by legacy back-nav helpers.
 */

export interface NavElement {
  currentRoute: string;
  fullRoute: string;
}

interface RouteStateInternal {
  current: NavElement | null;
  previous: NavElement | null;
}

const state: RouteStateInternal = { current: null, previous: null };

export function pushRouteState(nav: NavElement): void {
  state.previous = state.current;
  state.current = nav;
}

export function getPreviousURL(): string {
  return state.previous?.fullRoute ?? '';
}

export function getCurrentRouteState(): NavElement | null {
  return state.current;
}
